import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Page::Discover::Registry::Box @registry={{this.model.registry}} @box={{this.model.box}} @versions={{this.model.versions}} @providers={{this.model.providers}} />", {
  moduleName: "vagrant/templates/discover/registry/box/index.hbs"
});